import { useQuery } from "react-query";
import { fetchPatientReports } from "@/services/report";
/** Query hook for a patient's reports (for the letter report picker). */
export function usePatientReports(patientUid) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return useQuery(["patient-reports", patientUid], function () {
    return fetchPatientReports(patientUid);
  }, {
    enabled: Boolean(patientUid) && enabled
  });
}